import React, { useState } from 'react';

const doctorItem = require('b_')
    .with('doctor-item');
const link = require('b_')
    .with('link');

export const DoctorDescription = ({ description }) => {
    const [ isDescriptionVisible, toggleDescriptionVisibility ] = useState(false);

    return description ? (
        <div
            className={doctorItem('desc', {
                more: true,
                'is-opened': isDescriptionVisible,
            })}>
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
            <span onClick={() => toggleDescriptionVisibility(!isDescriptionVisible)} className={link()}>
                Подробнее
            </span>
            <p className={doctorItem('desc')}>{description}</p>
        </div>
    ) : null;
};
